export enum Chain {
  Optimism = 'optimism',
  OptimismGoerli = 'optimism-goerli',
  Arbitrum = 'arbitrum',
  ArbitrumGoerli = 'arbitrum-goerli',
}
